import React from "react";
import type { Icon } from "@phosphor-icons/react";

import type { StrategyCoverage } from "./welcomeFeatures";

export const NAVY = "#234E81";

export function BetaBadge() {
  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-cvcBody bg-cvc-green/20 text-cvc-green uppercase">
      BETA
    </span>
  );
}

export function FeatureCard({
  icon: FeatureIcon,
  title,
  description,
  isBeta,
}: {
  icon: Icon;
  title: string;
  description: string;
  isBeta?: boolean;
}) {
  return (
    <div className="bg-white border border-[rgba(52,52,52,0.15)] rounded-[5px] p-5">
      <div className="flex items-center gap-2">
        <FeatureIcon size={24} color={NAVY} />
        <span className="font-cvcBody text-sm" style={{ color: NAVY }}>
          {title}
        </span>
        {isBeta && <BetaBadge />}
      </div>
      <div className="border-b border-gray-200 my-2" />
      <p className="font-cvcBody text-xs leading-[18px] text-cvc-text">{description}</p>
    </div>
  );
}

export function CapabilityCard({
  icon: CapabilityIcon,
  title,
  description,
}: {
  icon: Icon;
  title: string;
  description: string;
}) {
  return (
    <div className="bg-white border border-[rgba(52,52,52,0.15)] rounded-[5px] p-4">
      <div className="flex items-start gap-2">
        <CapabilityIcon size={20} color={NAVY} />
        <span className="font-cvcBody text-sm leading-[21px]" style={{ color: NAVY }}>
          {title}
        </span>
      </div>
      <div className="border-b border-gray-200 my-2" />
      <p className="font-cvcBody text-xs leading-[18px] text-cvc-text">{description}</p>
    </div>
  );
}

export function StrategyColumn({ name, rows, status }: StrategyCoverage) {
  return (
    <div className="bg-[rgba(52,52,52,0.03)] rounded-[5px] p-3 h-full">
      <p className="font-cvcBody text-[11px] uppercase text-cvc-text mb-1">{name}</p>
      <div className={`font-cvcBody text-[11px] leading-4 text-cvc-text ${status === "available" ? "" : "opacity-50"}`}>
        {rows.map(([label, value]) => (
          <p key={label}>
            <span className="font-normal">{label}:</span> <span>{value}</span>
          </p>
        ))}
      </div>
    </div>
  );
}
